<template>
  <div class="hand">
    <span
      class="spanreg"
      :class="classview(item, index)"
      v-for="(item, index) in items"
      :key="index"
      @click="selData(index)"
      ><strong>{{ item.nombre }}:</strong>
      <span class="fontMono"
        >{{ item.input
        }}<span v-if="item.inputrich"> - {{ item.inputrich }}</span></span
      >
    </span>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    columna: Number,
    fila: Number,
    filaactual: Number,
  },
  methods: {
    selData(index) {
      this.$emit("columna", index + 1);
      this.$emit("fila", this.filaactual);
      setTimeout(function () {
        document.getElementById("inputItems").focus();
      }, 5);
    },
    classview(item, index) {
      let returned = {};
      if (item.css.status === "warning") {
        returned["has-text-warning"] = true;
      } else if (item.css.status === "danger") {
        returned["has-text-danger"] = true;
      } else if (item.css.status === "light") {
        returned["has-text-grey"] = true;
      }
      if (this.columna - 1 === index && this.fila === this.filaactual) {
        returned = {};
        returned["is-select"] = true;
      }
      return returned;
    },
  },
};
</script>

<style lang="scss" scoped>
.spanreg {
  padding: 3px 10px 3px 3px;
  border-radius: 6px;
}
.is-select {
  // background-color: #dadada;
  background-color: #5a5a5a;
  // background-color: #3273dc;
  // background-color: #ffdd57;

  color: #ffffff;
}
.has-text-warning {
  color: #e6b800 !important;
}
.has-text-grey {
  color: #aeaeae !important;
}
</style>


// WEBPACK FOOTER //
// src/components/facturar/componentsfra/Viewitems.vue